import { Group, Ctrl } from '@/components/control-panl'
import {
  AlignmentMode,
  AlignmentTransform,
  AlignmentHandler,
  DataSetRaw
} from '@/sdk'
import { Ref } from 'vue'
import { Message } from '@kankan/components/src/expose-common'
import { ui18n } from '@/lang'

const check = (datasets: Ref<DataSetRaw>) => {
  if (datasets.value.length) {
    return true
  } else {
    Message.warning(ui18n.t('dataset.setting.subtleTip'))
    return false
  }
}

export const genGroup = (
  alignment: AlignmentMode,
  datasets: Ref<DataSetRaw>
) => [
  {
    ctrls: [
      {
        icon: 'move',
        handler: () => {
          alignment.switchHandle(AlignmentHandler.translate)
        },
        unHandler: () => {
          alignment.switchHandle(null)
        },
        desc: ui18n.t('tool.move')
      },
      {
        icon: 'weitiao',
        handler: () => {
          // alignment.switchHandle(AlignmentHandler.translate)
        },
        desc: ui18n.t('dataset.setting.subtle'),
        children: [
          {
            text: '+x',
            handler: () =>
              check(datasets) && alignment.translate(AlignmentTransform['+x']),
            inClick: true
          },
          {
            text: '+y',
            handler: () =>
              check(datasets) && alignment.translate(AlignmentTransform['+y']),
            inClick: true
          },
          {
            text: '+z',
            handler: () =>
              check(datasets) && alignment.translate(AlignmentTransform['+z']),
            inClick: true
          },
          {
            text: '-x',
            handler: () =>
              check(datasets) && alignment.translate(AlignmentTransform['-x']),
            inClick: true
          },
          {
            text: '-y',
            handler: () =>
              check(datasets) && alignment.translate(AlignmentTransform['-y']),
            inClick: true
          },
          {
            text: '-z',
            handler: () =>
              check(datasets) && alignment.translate(AlignmentTransform['-z']),
            inClick: true
          }
        ]
      }
    ]
  },
  {
    apart: true,
    ctrls: [
      {
        icon: 'flip',
        handler: () => {
          alignment.switchHandle(AlignmentHandler.rotate)
        },
        unHandler: () => {
          alignment.switchHandle(null)
        },
        desc: ui18n.t('tool.rotate')
      },
      {
        icon: 'weitiao',
        handler: () => {
          // alignment.switchHandle(AlignmentHandler.rotate),
        },
        desc: ui18n.t('dataset.setting.subtle'),
        group: [
          { num: [0, 6], title: ui18n.t('view.top') },
          { num: [6, 12], title: ui18n.t('view.side') + '(N-S)' },
          { num: [12, 18], title: ui18n.t('view.side') + '(E-W)' }
        ],
        children: [
          {
            icon: 'rotate_l',
            text: '10°',
            handler: () => check(datasets) && alignment.rotate(10, 0),
            inClick: true
          },
          {
            icon: 'rotate_l',
            text: '1°',
            handler: () => check(datasets) && alignment.rotate(1, 0),
            inClick: true
          },
          {
            icon: 'rotate_l',
            text: '0.1°',
            handler: () => check(datasets) && alignment.rotate(0.1, 0),
            inClick: true
          },
          {
            text: '10°',
            icon: 'rotate_r',
            handler: () => check(datasets) && alignment.rotate(-10, 0),
            inClick: true
          },
          {
            text: '1°',
            icon: 'rotate_r',
            handler: () => check(datasets) && alignment.rotate(-1, 0),
            inClick: true
          },
          {
            text: '0.1°',
            icon: 'rotate_r',
            handler: () => check(datasets) && alignment.rotate(-0.1, 0),
            inClick: true
          },

          {
            icon: 'rotate_l',
            text: '10°',
            handler: () => check(datasets) && alignment.rotate(10, 1),
            inClick: true
          },
          {
            icon: 'rotate_l',
            text: '1°',
            handler: () => check(datasets) && alignment.rotate(1, 1),
            inClick: true
          },
          {
            icon: 'rotate_l',
            text: '0.1°',
            handler: () => check(datasets) && alignment.rotate(0.1, 1),
            inClick: true
          },
          {
            text: '10°',
            icon: 'rotate_r',
            handler: () => check(datasets) && alignment.rotate(-10, 1),
            inClick: true
          },
          {
            text: '1°',
            icon: 'rotate_r',
            handler: () => check(datasets) && alignment.rotate(-1, 1),
            inClick: true
          },
          {
            text: '0.1°',
            icon: 'rotate_r',
            handler: () => check(datasets) && alignment.rotate(-0.1, 1),
            inClick: true
          },

          {
            icon: 'rotate_l',
            text: '10°',
            handler: () => check(datasets) && alignment.rotate(10, 2),
            inClick: true
          },
          {
            icon: 'rotate_l',
            text: '1°',
            handler: () => check(datasets) && alignment.rotate(1, 2),
            inClick: true
          },
          {
            icon: 'rotate_l',
            text: '0.1°',
            handler: () => check(datasets) && alignment.rotate(0.1, 2),
            inClick: true
          },
          {
            text: '10°',
            icon: 'rotate_r',
            handler: () => check(datasets) && alignment.rotate(-10, 2),
            inClick: true
          },
          {
            text: '1°',
            icon: 'rotate_r',
            handler: () => check(datasets) && alignment.rotate(-1, 2),
            inClick: true
          },
          {
            text: '0.1°',
            icon: 'rotate_r',
            handler: () => check(datasets) && alignment.rotate(-0.1, 2),
            inClick: true
          }
        ]
      }
    ]
  }
]
export type CtrlAtom = ReturnType<typeof genGroup> extends Group<infer P>
  ? P
  : never
